module.exports = __webpack_public_path__ + "static/media/Polluter_Alert_App_recording.c6b38c07.mp4";